
type CoinsProps = {
    value: number | null | undefined;
}

export default function Coins({ value }: CoinsProps) {
    const safe = typeof value === "number" && Number.isFinite(value) ? value : 0
    return (
        <>
            {safe.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        </>
    )
}
